import { Box } from 'theme-ui'

import TextCommon from 'src/components/common/textCommon/TextCommon'

export interface TextBlockProps {
  title: string
  description: string
  options?: { charLimit?: number; lineLimit?: number }
}

const TextBlock = ({ title, description, options }: TextBlockProps) => (
  <Box sx={{ maxWidth: 'copy', px: [2, null, 4], py: [9, null, 11] }}>
    <TextCommon title={title} text={description} options={options} />
  </Box>
)

export default TextBlock
